<template>
       <div class="grids">
					<div class="progressbar-heading grids-heading">
						<h2>UPDATE MY INFO</h2>
					</div>
					<div class="panel panel-widget forms-panel">
						<div class="forms">
							<div class="form-grids widget-shadow" data-example-id="basic-forms"> 
								<div class="form-title">
									<h4>MY INFO</h4>
								</div>
								<div class="form-body">
									              <form v-on:submit.prevent="handleSubmit()"> 
                                    <div class="form-group"> 
                                    <label for="FName">First Name</label> 
                                    <input type="text" class="form-control" id="FName" v-model="firstname" v-on:change="handleFirstName($event)" >
                                     </div> 
                                     <div class="form-group">
                                      <label for="LName">Last Name</label> 
                                      <input type="text" class="form-control" id="LName"  v-model="lastname" v-on:change="handleLastName($event)" >
                                       </div> 
                                       <div class="form-group">
                                      <label for="OName">Other Name</label> 
                                      <input type="text" class="form-control" id="OName" v-model="othername" v-on:change="handleOtherName($event)" >
                                       </div> 
                          
                                          <button type="submit" class="btn btn-default">Submit</button>
                                  </form> 
								</div>
							</div>
						</div>
					</div>
					<p>First Name: {{firstname}}</p>
					
          <p>Last Name: {{lastname}}</p>
					<p>Other Name: {{othername}}</p>

                    
                    <button @click="logout()" class="btn btn-default">logout</button>
				</div>
</template>

<script>
import axios from "axios";


export default {
  name: 'About',
  props: {
    
},
data()
{
  return{
      firstname: null,
      lastname: null,
      othername: null
  }
},
mounted()
{

},
async created()
{
  try
  {
    //get user access token
    let token = localStorage.getItem("token");
    //alert(token);
    if((token == "noToken") || (token == null))
    {
      alert("Ilegal page view");
      return this.$router.push("/timeawards/");
    }

     let userDataResponse = await axios({
       method: "get",
       url: "https://time-person-mofe.herokuapp.com/api/dashboard/profile",
       headers: {"Authorization": "Bearer "+token}
     });

    let requestStatus = userDataResponse.data.status;

    if(requestStatus == "success")
    {
      let userData = userDataResponse.data.userDetails;
      this.firstname = userData.firstName;
      this.lastname = userData.lastName;
      this.othername = userData.otherName;
      
    }
    else{
        //revoke token
        localStorage.setItem("token","noToken");
        
      //redirect away from dashboard
      this.$router.push("/timeawards/");
    }

  }
  catch(error)
  {
      //revoke token
        localStorage.setItem("token","noToken");
    
    alert("User data not available please refresh page."+error);

    //redirect away from dashboard
    this.$router.push("/timeawards/");
  }
 
},
methods:
{
  handleSubmit: async function()
  {
    //fire axios update request
    if((this.firstname != null) && (this.firstname != "") && (this.lastname != null) && (this.lastname != "") && (this.othername != null) && (this.othername != ""))
    {
      try
  {
    //get user access token
    let token = localStorage.getItem("token");
    
     let userDataResponse = await axios({
       method: "post",
       url: "https://time-person-mofe.herokuapp.com/api/dashboard",
       data:{firstName: this.firstname,
            middleName: this.othername,
            lastName: this.lastname
          },
       headers: {"Authorization": "Bearer "+token}
     });

    let requestStatus = userDataResponse.data.status;

    if(requestStatus == "success")
    {
      //let userData = userDataResponse.data.userDetails;
      alert("Data saved successfully!");
      //this.firstname = userData.firstName;
     // this.lastname = userData.lastName;
     // this.othername = userData.otherName;
      
    }
    else{
      //redirect away from dashboard
      this.$router.push("/timeawards/");
    }

  }
  catch(error)
  {
    alert("User data update not successful "+error);

  }
    }
    else
    {
       alert("Please fill form properly before submitting");
    }
  },
  handleFirstName: function(e)
  {
    this.firstname = e.target.value;
  },
  handleLastName: function(e)
  {
    this.lastname = e.target.value;
  },
  handleOtherName: function(e)
  {
    this.othername = e.target.value;
  },
  logout: function()
  {
    
    this.$router.push("/timeawards/logout");
  }

}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
